import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Calendar } from 'react-date-range'
import classes from 'classnames'
import { parseISO } from 'date-fns'
import onClickOutside from 'react-onclickoutside'

import { values, noop, isString } from 'lodash'

import { utils, ui } from 'parking-react-common'

import FormGroup from '../components/FormGroup'
import Icon from '../components/Icon'

import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'

import './DatePickerInput.css'

class DatePickerInput extends Component {
    constructor(props) {
        super(props)
        this.state = { isFocused: false }
    }

    handleFocus() {
        const { input: { onFocus } } = this.props
        this.setState({ isFocused: true })
        onFocus()
    }

    handleBlur() {
        const { input: { onBlur } } = this.props
        this.setState({ isFocused: false })
        onBlur()
    }

    handleClickOutside() {
        this.setState({ isFocused: false })
    }

    render() {
        const { input, meta, label, description, size, isHorizontal } = this.props
        const { name, value, onChange } = input
        const { error } = meta

        const { isFocused } = this.state

        const dateValue = isString(value)
            ? parseISO(value)
            : value

        return (
            <FormGroup
                name={ name }
                label={ label }
                error={ error }
                description={ description }
                isHorizontal={ isHorizontal }
                hasFeedback
            >
                <input
                    value={ utils.formatPrettyDate(dateValue) || '' }
                    className={ classes('form-control', `input-${size}`, 'date-picker-input') }
                    onFocus={ () => this.handleFocus() }
                    onChange={ noop }
                />
                <span className="form-control-feedback">
                    <Icon name="fa/calendar" size={ 18 } />
                </span>
                { isFocused && (
                    <div className="date-picker-calendar">
                        <Calendar
                            date={ dateValue }
                            onChange={ (value) => {
                                onChange(value)
                                this.handleBlur()
                            } }
                        />
                    </div>
                ) }
            </FormGroup>
        )
    }
}

DatePickerInput.propTypes = {
    label        : PropTypes.string,
    input        : PropTypes.object,
    meta         : PropTypes.object,
    description  : PropTypes.string,
    size         : PropTypes.oneOf(values(ui.SIZE)),
    isHorizontal : PropTypes.bool
}

DatePickerInput.defaultProps = {
    size: ui.SIZE.small
}


export default onClickOutside(DatePickerInput)
